export const SERVICE_REQUEST_TYPES = {
  HOSPITAL_APPOINTMENT: 'Hospital Appointment',
  DIAGNOSTIC_TEST: 'Diagnostic Test',
  INSURANCE_SUPPORT: 'Insurance Support',
  AMBULANCE: 'Ambulance',
  HOME_CARE: 'Home Care',
  COORDINATOR_CONTACT: 'Service Coordinator'
} as const;

export const SERVICE_REQUEST_STATUS = {
  REQUESTED: 'Requested',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
} as const;

export const MEMBERSHIP_TYPES = {
  INDIVIDUAL: 'Individual',
  FAMILY: 'Family',
  CORPORATE: 'Corporate'
} as const;

export const MEMBERSHIP_STATUS = {
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
  SUSPENDED: 'Suspended'
} as const;

export const PAYMENT_STATUS = {
  PENDING: 'Pending',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  REFUNDED: 'Refunded'
} as const;
